const initMap = () => {
    const el = document.querySelector("#googleMap");
    if (!el) return false;
  
    const center = {
      lat: parseFloat(el.dataset.lat),
      lng: parseFloat(el.dataset.lng),
    };
    const zoom = parseInt(el.dataset.zoom);
    const icon = {
      url: "/app/themes/cliftoncoffee/dist/images/coffee-marker.png",
      scaledSize: new google.maps.Size(29, 40),
    };
  
    const map = new google.maps.Map(el, {
      center: center,
      zoom,
      disableDefaultUI: true,
      styles: [
        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          // point of interest
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          // park land
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#EEEEEE" }],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{ color: "#6b9a76" }],
        },
        {
          featureType: "poi.business",
          elementType: "geometry.fill",
          stylers: [{ visibility: "on" }, { color: "#EEEEEE" }],
        },
        {
          featureType: "poi.school",
          elementType: "geometry.fill",
          stylers: [{ color: "#EEEEEE" }, { visibility: "on" }],
        },
        {
          // roads
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9ca5b3" }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#DADADA" }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#dadada" }],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          // transit
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#e5e5e5" }],
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          // water
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#c9c9c9" }],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#515c6d" }],
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#17263c" }],
        },
        {
          featureType: "transit.station.rail",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
      ],
    });
    new google.maps.Marker({ position: center, icon, map });
};

$(document).ready(function(){
    $('#googleMap').each(function(){
        var map = initMap( $(this) );
    });
});
